let elements = {
  withoutReset: true,
  mainImage: {
    imagePath: 'games/page000_game1/img/bcg.jpg',
    pos: {
      x: 183,
      y: 0,
    },
    width: 1554,
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  mbAudioItemData: [
    {
      src: 'games/page000_game1/audio/12_purple.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game1/img/audioOn.png', iconOff: 'games/page000_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '50px',
      height: '50px',
      pos: {
        y: 108,
        x: 1446,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game1/audio/13_pink.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game1/img/audioOn.png', iconOff: 'games/page000_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '50px',
      height: '50px',
      pos: {
        y: -10,
        x: 934,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game1/audio/14_orange.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game1/img/audioOn.png', iconOff: 'games/page000_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '50px',
      height: '50px',
      pos: {
        y: 146,
        x: 434,
      },
      unit: 'px',
    },
  ],
};

export default elements;
